const Landing = () => {
  return (
    <>
      <div className="hero" data-testid="hero-section">
        <div className="hero-inner">
          <div className="logo-ring" data-testid="hero-logo">
            <div className="logo-ring-inner">
              <span role="img" aria-label="eye">
                👁
              </span>
            </div>
          </div>
          <h1 data-testid="hero-title">FortellAI</h1>
          <p className="tagline" data-testid="hero-tagline">
            AI-powered mystical readings.
            <br />
            Your palm, your coffee, your aura — decoded.
          </p>

          <div className="stores">
            <a
              className="store-btn"
              href="https://apps.apple.com/us/app/fortellai/id6786931283"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="appstore-btn"
            >
              <span className="store-icon"></span>
              <span>
                <small>Download on the</small>
                <b>App Store</b>
              </span>
            </a>
          </div>

          <p className="soon" data-testid="launch-soon">
            Now available on iOS ✦ Android coming soon
          </p>
        </div>
      </div>

      <section data-testid="features-section">
        <h2>Four ways to glimpse your destiny</h2>
        <div className="grid">
          <div className="card" data-testid="feature-hand-scan">
            <img
              src="https://images.unsplash.com/photo-1556703588-6eae2585e025?w=800&q=70&fm=jpg"
              alt="Palm reading"
            />
            <div className="scrim"></div>
            <div className="txt">
              <h3>Hand Scan</h3>
              <p>
                AI palm reading — love, career, personality, future &amp; luck from your destiny
                lines.
              </p>
            </div>
          </div>
          <div className="card" data-testid="feature-coffee-reading">
            <img
              src="https://images.pexels.com/photos/37823244/pexels-photo-37823244.jpeg?auto=compress&cs=tinysrgb&w=800"
              alt="Coffee cup reading"
            />
            <div className="scrim"></div>
            <div className="txt">
              <h3>Coffee Reading</h3>
              <p>Snap your cup and the oracle interprets the symbols hidden in the grounds.</p>
            </div>
          </div>
          <div className="card" data-testid="feature-face-scan">
            <img
              src="https://images.unsplash.com/photo-1650186278611-f626ec1bbad6?w=800&q=70&fm=jpg"
              alt="Aura reading"
            />
            <div className="scrim"></div>
            <div className="txt">
              <h3>Face Scan</h3>
              <p>
                Discover your aura color, emotional energy and future vibes. No biometrics stored.
              </p>
            </div>
          </div>
          <div className="card" data-testid="feature-object-scan">
            <img
              src="https://images.unsplash.com/photo-1558467778-cde0a483cb48?w=800&q=70&fm=jpg"
              alt="Mystical objects"
            />
            <div className="scrim"></div>
            <div className="txt">
              <h3>Object Scan</h3>
              <p>Scan anything — receive its symbolic meaning and the universe's message.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="steps" data-testid="how-it-works-section">
        <h2>How it works</h2>
        <div className="steps-row">
          <div className="step" data-testid="step-scan">
            <div className="ic">
              <span role="img" aria-label="camera">
                📷
              </span>
            </div>
            <h3>1 · Scan</h3>
            <p>Take a photo of your palm, cup, face or any object.</p>
          </div>
          <div className="step" data-testid="step-ai-reads">
            <div className="ic">
              <span role="img" aria-label="sparkles">
                ✨
              </span>
            </div>
            <h3>2 · AI reads</h3>
            <p>Advanced AI interprets the signs and symbols.</p>
          </div>
          <div className="step" data-testid="step-save-share">
            <div className="ic">
              <span role="img" aria-label="crystal ball">
                🔮
              </span>
            </div>
            <h3>3 · Save &amp; share</h3>
            <p>Keep your readings and share them with friends.</p>
          </div>
        </div>
      </section>

      <footer data-testid="site-footer">
        <div className="brand serif">
          <span role="img" aria-label="eye">
            👁
          </span>{" "}
          FortellAI
        </div>
        <p>
          For entertainment purposes only. No biometric data is stored and no face recognition is
          performed.
        </p>
        <div>
          <a href="/privacy" data-testid="footer-privacy-link">
            Privacy Policy
          </a>
          ·
          <a href="/terms" data-testid="footer-terms-link">
            Terms of Service
          </a>
        </div>
        <p className="copy">© 2026 FortellAI · www.fortellai.ca</p>
      </footer>
    </>
  );
};

export default Landing;
